import { useState } from 'react'
import { Text } from 'react-native'
import styled from 'styled-components'
import { useStartSubscriptionMutation, useSubscriptionPlansQuery } from '@mwxltd/flix-api-client'
import bugsnag from '../../services/bugsnag'
import { PayPalButton, PayPalPlaceholder } from './PayPalButton'

const ErrorMessage = styled(Text)`
  align-self: center;
  text-align: center;
  color: ${(props) => props.theme.colors.error};
  font-size: ${(props) => props.theme.fontSizes.medium}px;
  margin-bottom: ${(props) => props.theme.spacing.md}px;
`

export const PayPalSubscriptionButton = ({ chosenPlan }) => {
  const {
    loading,
    data: { plans, paypalClientId },
  } = useSubscriptionPlansQuery({ provider: 'paypal' }, { fetchPolicy: 'cache-and-network' })

  const chosenPayPalPlan = chosenPlan && plans.find((plan) => plan.type === chosenPlan.type)

  const [startSubscription] = useStartSubscriptionMutation(chosenPayPalPlan, {
    ignoreResults: true,
  })

  const [hasError, setError] = useState(false)

  if (loading) {
    return <PayPalPlaceholder />
  }

  return (
    <>
      <PayPalButton
        paypalClientId={paypalClientId}
        createSubscription={(data, actions) =>
          actions.subscription.create({
            plan_id: chosenPayPalPlan.sku,
          })
        }
        onApprove={(data) =>
          startSubscription('paypal', { subscriptionId: data.subscriptionID }).then(({ data }) => {
            if (!data) setError(true)
          })
        }
        onError={(error) => {
          setError(true)
          bugsnag.notify(error)
        }}
      />
      {hasError && (
        <ErrorMessage>
          There was an error starting your subscription. Please contact support@flixpremiere.com.
        </ErrorMessage>
      )}
    </>
  )
}
